import { useCompanyStore } from '@Stores/company.store';
import type { TrackingPayloadPrimitive, TrackingPayload } from '@Shared';


export class TrackingPayloadBuilder {
    private payload: TrackingPayload;

    constructor(context?: string) {
        const companyStore = useCompanyStore();
        const requestType = context ?? "Unknown";

        this.payload = {
            'Request Type': requestType,
            'Account Id': companyStore.company?.id ?? null,
            'Account Name': companyStore.company?.name ?? null
        };
    }

    withValidationType(validationType: string) {
        this.payload['Validation type'] = validationType;
        return this;
    }
    
    withCodeResentFlag(codeResentFlag: boolean) {
        this.payload['Code resent'] = codeResentFlag;
        return this;
    }

    withSupportLinkVist(supportLinkViewed: boolean) {
        this.payload['Support link visited'] = supportLinkViewed;
        return this;
    }

    withCustomField(label: string, value: TrackingPayloadPrimitive) {
        this.payload[label] = value;
        return this;
    }

    build():TrackingPayload {
        return { ...this.payload };
    }
}
